import { Col, Form, Row, Select, Space, Switch, Table, message } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { ColumnsType } from 'antd/es/table';
import CabinetApi from 'apis/CabinetApi';
import { EditIcon, EyeIcon, FilterGoldIcon, FilterIcon } from 'assets/svg';
import { MainLayout } from 'components';
import Button from 'components/Button';
import useQueryParam from 'hooks/useQueryPrams';
import { Icabinet } from 'interface/cabinet.interface';
import { IGetUserQuery } from 'interface/user.interface';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import pageTitleStore from 'store/pageTitleStore';
import { HocChangePagination } from 'utils/HocChangePagination';

export default function CabinetPage() {
  const history = useHistory();
  const queryParam = useQueryParam();

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size = parseInt(queryParam.get('page_size') + '') || 10;
  const functionParams = {
    page: page,
    page_size: page_size,
  };

  const params = JSON.parse(JSON.stringify(functionParams));

  const search = queryParam.get('search') || undefined;
  const fullName = queryParam.get('fullName') || undefined;
  const email = queryParam.get('email') || undefined;
  const jobTitleCode = queryParam.get('jobTitleCode') || undefined;
  const departmentCode = queryParam.get('departmentCode') || undefined;
  const plantCode = queryParam.get('plantCode') || undefined;
  const categoryParams: IGetUserQuery = {
    page,
    page_size,
    search,
    fullName,
    email,
    jobTitleCode,
    departmentCode,
    plantCode,
  };
  const { data, isLoading: getUsersLoading } = useQuery({
    queryKey: ['getUsers', categoryParams],
    queryFn: () => {
      return { data: [] as any, total: 0 };
    },
    select: (data: any) => {
      if (data?.data?.length <= 0) {
        data.data = [];
      }
      return data;
    },
  });

  type FixedType = 'left' | 'right' | boolean;

  const {
    data: cabinetResult,
    isLoading,
    refetch,
  } = useQuery(['getCabinet', params], () => CabinetApi.getCabinet(params));

  const columns: ColumnsType<any> = [
    {
      title: 'Mã tủ',
      dataIndex: 'id',
      width: 100,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Mô hình',
      dataIndex: 'model',
      width: 120,
    },
    {
      title: 'Loại tủ',
      dataIndex: 'description',
      width: 200,
    },
    {
      title: 'Hình ảnh',
      width: 150,
      render: (_: any, record: Icabinet) => {
        return (
          <img style={{ width: 80, height: 80 }} src={record?.image} alt="" />
        );
      },
    },
    {
      title: 'Ngang',
      dataIndex: 'horizontal',
      width: 120,
    },

    {
      title: 'dọc',
      width: 120,
      dataIndex: 'vertical',
    },
    {
      title: 'Tên tủ',
      width: 200,
      dataIndex: 'description',
    },
    {
      title: (
        <div>
          Số lượng món tối thiểu <br /> <span>(khuyến nghị)</span>
        </div>
      ),
      dataIndex: 'min_product',
      width: 250,
    },
    {
      title: 'SL',
      width: 100,
      render: (_: any, record: Icabinet) => {
        return <p>-</p>;
      },
    },
    {
      title: 'Thao tác',
      fixed: 'right' as FixedType,
      align: 'center',
      width: 150,
      render: (_: any, record: any) => (
        <div className="flex justify-around">
          <button
            onClick={() => {
              // history.push(`/department-approval/detail/${record.id}`);
            }}
          >
            <EyeIcon />
          </button>
          <button
            onClick={() => {
              // history.push(`/department-approval/edit/${record.id}`);
            }}
          >
            <EditIcon />
          </button>
          <div>
            <Switch size="small" defaultChecked onChange={SwitchOnChange} />
          </div>
        </div>
      ),
    },
  ];

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const SwitchOnChange = (checked: boolean) => {
    console.log(`switch to ${checked}`);
  };

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  useEffect(() => {
    setTitle('Tủ, dòng hàng');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/">Thiết lập</a>
          </p>
        ),
      },
      {
        title: <a href="/branch-cabinet">Tủ, dòng hàng</a>,
      },
    ]);
  }, []);

  return (
    <MainLayout isLoading={isLoading}>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
        <Col span={12} className="flex justify-end">
          <Space>
            {/* <Button
              onClick={() => {
                history.push(`/branch-cabinet/create`);
              }}
            >
              <AddIcon />
              Tạo mới
            </Button> */}
            <Button
              bgColor={'bg-white'}
              color={`${
                isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
              }`}
              border={`${
                isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
              }`}
              onClick={toggleFilter}
            >
              {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>

      <Form
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'}`}
        // onSubmitCapture={formik.handleSubmit}
        autoComplete="off"
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={6}>
              <Form.Item label="Mô hình">
                <Select
                  allowClear={true}
                  placeholder="Tìm kiếm theo mô hình"
                  size="middle"
                  // onChange={handleChangeSelect('division_id')}
                >
                  {/* {renderDivisionOptions((resultDivision?.data || []) as any)} */}
                </Select>
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item label="Loại tủ">
                <Select
                  allowClear={true}
                  placeholder="Tìm kiếm theo loại tủ"
                  size="middle"
                  // onChange={handleChangeSelect('division_id')}
                >
                  {/* {renderDivisionOptions((resultDivision?.data || []) as any)} */}
                </Select>
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item label="Tên tủ">
                <Select
                  allowClear={true}
                  placeholder="Tìm kiếm theo khối tên tủ"
                  size="middle"
                  // onChange={handleChangeSelect('division_id')}
                >
                  {/* {renderDivisionOptions((resultDivision?.data || []) as any)} */}
                </Select>
              </Form.Item>
            </Col>
            <Col className="" span={6}>
              <Form.Item label="Trạng thái">
                <Select
                  allowClear={true}
                  placeholder="Tìm kiếm theo trạng thái"
                  size="middle"
                  // onChange={handleChangeSelect('division_id')}
                >
                  {/* {renderDivisionOptions((resultDivision?.data || []) as any)} */}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
            <Col className="flex justify-end" span={8}>
              <Space>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-primary-50'}
                  onClick={toggleFilter}
                >
                  Hủy
                </Button>
                <Button type="submit">Tìm kiếm</Button>
              </Space>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content className="main-content mt-4">
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          scroll={{ x: 858 }}
          className="customTable"
          dataSource={cabinetResult?.data}
          loading={getUsersLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: data?.total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </MainLayout>
  );
}
